import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Collapse, IconButton, useTheme } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { UIContext } from '../../../../context/UIContext';

interface MobileRowStructureProps {
  mainContent: React.ReactNode;
  expandableContent?: React.ReactNode;
  hasExpandableContent?: boolean;
}

const MobileRowStructure = ({
  mainContent,
  expandableContent,
  hasExpandableContent = true,
}: MobileRowStructureProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { colorMode } = useContext(UIContext);
  const [open, setOpen] = React.useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const borderColor =
    colorMode === 'light' ? theme?.palette?.grey?.['12p'] : theme?.palette?.grey?.['23p'];
  const commonStyles = {
    borderRadius: 0,
    borderBottom: `1px ${borderColor} solid`,
    padding: '0.5rem 1rem',
  };

  if (!hasExpandableContent) {
    return (
      <Box sx={{ ...commonStyles, padding: '0.5rem 1rem' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {mainContent}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={commonStyles}>
      <IconButton
        aria-label={open ? t('actions.lessInfo') : t('actions.moreInfo')}
        size="small"
        onClick={handleToggle}
        sx={{ width: '100%', borderRadius: 0, padding: '0.5rem 1rem', color: 'inherit' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          {mainContent}
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </Box>
      </IconButton>
      {expandableContent && (
        <Collapse in={open} timeout="auto" unmountOnExit sx={{ padding: '0.5rem 1rem' }}>
          {expandableContent}
        </Collapse>
      )}
    </Box>
  );
};

export default MobileRowStructure;
